import { render, staticRenderFns } from "./unbundleTravle.vue?vue&type=template&id=07b4d671&scoped=true"
import script from "./unbundleTravle.vue?vue&type=script&lang=js"
export * from "./unbundleTravle.vue?vue&type=script&lang=js"
import style0 from "./unbundleTravle.vue?vue&type=style&index=0&id=07b4d671&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4d671",
  null
  
)

export default component.exports